import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { assetWithdraw } from "store/actions";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import transakImg from '../../assets/images/transak.jpeg'
import ScrollLockModal from "Component/Common/ScrollLock-Model";

export default function ViewMoreModel(props) {

  /**
     * Used for render the UI of view more on transaction history table
     */
    return (
        <ScrollLockModal
            {...props}

            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="buy_modal Tranferconfirm-modal"
        >

     
                <div className="modal_inner_main position-relative">
                    <a
                        href="javascript:void(0)"
                        onClick={() => {
                            props.onHide();

                        }}
                        className="close-btn"
                    >
                        <img src="/images/close_img.png" alt="" className="img-fluid" />
                    </a>


                    <div className="modal_buy-cont">

                        <div className="details_box_innermod text-start">


                            <div className="from_to_wrap d-flex align-item-center justify-content-between">
                                <div className="from_wrap">
                                    <h5 className="text-start">Wallet Address</h5>

                                    <div className="address_show d-flex align-item-center">
                                        <div className="address_img">
                                            <img src={transakImg} className="img-fluid" />
                                        </div>
                                        <p className=" w-50">{props?.selectedItem?.walletAddress}</p>
                                    </div>
                                </div>
                               
                            </div>

                            <ul className="p-0 m-0 details_list mt-2">
                                <li>
                                    <p> Amount Paid</p>
                                    <p>
                                        <strong>{props?.selectedItem?.amountPaid}</strong>
                                    </p>
                                </li>
                             
                                <li>
                                    <p> Crypto Amount</p>
                                    <p>
                                        <strong>{props?.selectedItem?.cryptoAmount}</strong>
                                    </p>
                                </li>
                             

                                <li>
                                    <p>Conversion Price</p>
                                    <p>
                                        <strong>{props?.selectedItem?.conversionPrice}</strong>
                                    </p>
                                </li>


                                <li>
                                    <p>Status</p>
                                    <p>
                                        <strong>{props?.selectedItem?.status }</strong>
                                    </p>
                                </li>


                            </ul>
                        </div>


                        <div className="modal_buy_btn d-flex justify-content-center gap-3 mt-2">
                            <Button
                                className="mod_cancelbtn copy_btn"
                                onClick={() => {
                                    props.onHide();

                                }}
                            >
                                Close
                            </Button>

                        </div>
                    </div>
                </div>
         
        </ScrollLockModal>
    );
}
